import { useDateFormatter } from "@/hooks/useUserPreferences";
import avatarUrl from "@/lib/image-urls";
import { useSessionQuery } from "@/queries/queries";
import type { ActivityItem } from "@/types/messages";
import { Avatar, AvatarImage } from "../ui/avatar";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import ChatMessage from "./ChatMessage";
import TaskUpdate from "./TaskUpdate";

export default function ChatMessages({ activityItem }: { activityItem: ActivityItem }) {
    const { data: session } = useSessionQuery();
    const { formatDateTime, formatRelativeDate } = useDateFormatter();
    if (!session) return null;

    if (activityItem.type === "update") {
        return <TaskUpdate activityItem={activityItem} />;
    }

    return (
        <div className="grid transition-[grid-template-rows] duration-300 ease-in-out py-2">
            <div className="overflow-hidden">
                <div className="flex items-end gap-2">
                    <Avatar className="size-6 mb-0.5">
                        <AvatarImage src={avatarUrl(activityItem.user.image, "40")} />
                    </Avatar>
                    <div>
                        <Tooltip>
                            <TooltipTrigger
                                delay={1000}
                                render={
                                    <div className="text-xs text-zinc-400 mb-1">
                                        {activityItem.user.name} - {formatRelativeDate(activityItem.createdAt)}
                                    </div>
                                }
                            ></TooltipTrigger>
                            <TooltipContent>{formatDateTime(activityItem.createdAt)}</TooltipContent>
                        </Tooltip>

                        <div className="flex flex-col gap-1">
                            {activityItem.type === "messagegroup" &&
                                activityItem.messages?.map((message) => (
                                    <ChatMessage
                                        currentUserId={session!.user!.id}
                                        key={`msg_${message.idempotencyKey}`}
                                        message={message}
                                    />
                                ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
